import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerXmarkRoundLine = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998a1 1 0 0 0-1.627-.78L6.315 9.286H4.001a1 1 0 0 0-1 1v4.288a1 1 0 0 0 1 1h2.372l5.085 3.27a1 1 0 0 0 1.541-.84V5.998Zm-5.706 5.067 3.705-2.98v8.085l-3.79-2.438a1 1 0 0 0-.542-.16H5.001v-2.287h1.666a1 1 0 0 0 .627-.22Zm6.999-2.272a1 1 0 0 1 1.414 0l1.793 1.793 1.793-1.793a1 1 0 1 1 1.414 1.414L18.914 12l1.793 1.793a1 1 0 0 1-1.414 1.414L17.5 13.414l-1.793 1.793a1 1 0 0 1-1.414-1.414L16.086 12l-1.793-1.793a1 1 0 0 1 0-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerXmarkRoundLine);
export default Memo;
